export default "__VITE_ASSET__DRLmpxio__"